export interface Pillar {
  id: string;
  icon: 'Workflow' | 'Wrench' | 'ShieldCheck';
  title: string;
  body: string;
  accentClass: 'p' | 'm' | 'a';
}

export const PILLARS: readonly Pillar[] = [
  {
    id: 'optimiser',
    icon: 'Workflow',
    title: 'Optimiser les processus',
    body: "J'analyse les opérations, j'identifie les pertes de temps et je mets en place des solutions durables.",
    accentClass: 'p',
  },
  {
    id: 'numeriser',
    icon: 'Wrench',
    title: 'Numériser intelligemment',
    body: 'Je développe les outils lorsque ceux du marché ne répondent pas aux besoins du terrain.',
    accentClass: 'm',
  },
  {
    id: 'qualite',
    icon: 'ShieldCheck',
    title: 'Renforcer la qualité',
    body: 'Je conçois des systèmes qui améliorent la traçabilité, réduisent les erreurs et facilitent les audits.',
    accentClass: 'a',
  },
];
